export const fullAlertFilterConfig = [
  {
    type: 'section',
    label: 'Alert state',
    items: [
      { id: 'open', title: 'Open' },
      { id: 'dismissed', title: 'Dismissed' },
      { id: 'resolved', title: 'Resolved' },
    ],
  },
  {
    type: 'section',
    label: 'With AI',
    items: [
      { id: 'processing', title: 'Processing' },
      { id: 'needs_attention', title: 'Needs attention' },
      { id: 'resolved_via_ai', title: 'Resolved via AI' },
    ],
  },
  {
    type: 'section',
    label: 'Critical alerts',
    toggleKey: 'showCritical',
    colorDot: '#DE1135',
    items: [
      {
        id: 'temperature_excursion_detected',
        title: 'Temperature excursion',
      },
      {
        id: 'temperature_excursion_pre_alarm',
        title: 'Temperature excursion (pre-alarm)',
      },
      { id: 'viability_window_exhausted', title: 'Viability window expired' },
    ],
  },
  {
    type: 'section',
    label: 'At-risk alerts',
    toggleKey: 'showAtRisk',
    colorDot: '#F6BC2F',
    linkedIds: [
      'low_battery_at_origin',
      'driver_late_to_pickup',
      'flight_delayed',
      'shipment_not_loaded_onto_flight',
      'sensor_location_still_at_pickup',
      'offload_delay_after_flight_arrival',
      'driver_late_to_recover_shipment',
      'sensor_location_not_at_drop',
      'driver_cant_find_location',
      'delivered_to_wrong_address',
      'delivered_to_wrong_recipient',
      'proof_of_delivery_missing',
      'low_battery',
      'flight_landing_close_to_cargo_closing_time',
      'weather_event_impact_expected',
      'status_update_overdue',
      'vehicle_idle_in_transit',
      'temperature_nearing_limit',
      'viability_window_nearly_exhausted',
      'excessive_light_exposure_detected',
      'excessive_tilt_detected',
      'excessive_pressure_detected',
      'excessive_humidity_detected',
      'excessive_shock_detected',
      'delivery_overdue',
      'transport_provider_exception',
      'viability_window_risk_expiring',
      'viability_at_risk_before_arrival',
      'vessel_delayed_or_cancelled',
    ],
  },
  {
    type: 'category',
    label: 'Pre-pick',
    items: [{ id: 'low_battery_at_origin', title: 'Low battery at origin' }],
  },
  {
    type: 'category',
    label: 'Pre-flight',
    items: [
      { id: 'driver_late_to_pickup', title: 'Pickup Overdue' },
      {
        id: 'flight_delayed',
        title: 'Flight delayed',
      },
      {
        id: 'shipment_not_loaded_onto_flight',
        title: 'Shipment not loaded onto flight',
      },
      {
        id: 'sensor_location_still_at_pickup',
        title: 'Sensor location still at pickup',
      },
    ],
  },
  {
    type: 'category',
    label: 'Post-flight',
    items: [
      {
        id: 'offload_delay_after_flight_arrival',
        title: 'Offload delay after flight arrival',
      },
      {
        id: 'driver_late_to_recover_shipment',
        title: 'Driver late to recover shipment',
      },
      {
        id: 'sensor_location_not_at_drop',
        title: 'Sensor location not at drop',
      },
    ],
  },
  {
    type: 'category',
    label: 'At delivery',
    items: [
      { id: 'driver_cant_find_location', title: "Driver can't find location" },
      {
        id: 'delivered_to_wrong_address',
        title: 'Incorrect delivery location',
      },
      {
        id: 'delivered_to_wrong_recipient',
        title: 'Delivered to wrong recipient',
      },
      {
        id: 'proof_of_delivery_missing',
        title: 'Proof of Delivery (POD) missing',
      },
      { id: 'delivery_overdue', title: 'Delivery Overdue' },
    ],
  },
  {
    type: 'category',
    label: 'Continuous monitoring',
    items: [
      {
        id: 'weather_event_impact_expected',
        title: 'Weather event impact expected',
      },
      {
        id: 'status_update_overdue',
        title: 'Status update overdue',
      },
      {
        id: 'flight_landing_close_to_cargo_closing_time',
        title: 'Cargo cut-off warning',
      },
      {
        id: 'viability_window_risk_expiring',
        title: 'Viability window warning',
      },
      {
        id: 'viability_at_risk_before_arrival',
        title: 'Viability at risk before arrival',
      },
      {
        id: 'viability_window_nearly_exhausted',
        title: 'Viability window nearly expired',
      },
      {
        id: 'low_battery',
        title: 'Low battery',
      },
      {
        id: 'vehicle_idle_in_transit',
        title: 'Vehicle idle in transit',
      },
      { id: 'temperature_nearing_limit', title: 'Temperature nearing limit' },
      {
        id: 'excessive_light_exposure_detected',
        title: 'Light exposure',
      },
      { id: 'excessive_tilt_detected', title: 'Tilt threshold exceeded' },
      {
        id: 'excessive_pressure_detected',
        title: 'Pressure range exceeded',
      },
      {
        id: 'excessive_humidity_detected',
        title: 'Humidity range exceeded',
      },
      {
        id: 'excessive_shock_detected',
        title: 'Shock threshold exceeded',
      },
      {
        id: 'transport_provider_exception',
        title: 'Transport provider exception',
      },
    ],
  },
  {
    type: 'category',
    label: 'Other',
    items: [
      {
        id: 'vessel_delayed_or_cancelled',
        title: 'Vessel delayed or cancelled',
      },
    ],
  },
];

export const sectionMap = {
  alert_state: ['open', 'dismissed', 'resolved'],
  critical_alerts: [
    'temperature_excursion_detected',
    'viability_window_exhausted',
  ],
  at_risk_alerts: [
    'low_battery_at_origin',
    'driver_late_to_pickup',
    'flight_delayed',
    'shipment_not_loaded_onto_flight',
    'sensor_location_still_at_pickup',
    'offload_delay_after_flight_arrival',
    'driver_late_to_recover_shipment',
    'sensor_location_not_at_drop',
    'driver_cant_find_location',
    'delivered_to_wrong_address',
    'delivered_to_wrong_recipient',
    'proof_of_delivery_missing',
    'low_battery',
    'flight_landing_close_to_cargo_closing_time',
    'weather_event_impact_expected',
    'status_update_overdue',
    'vehicle_idle_in_transit',
    'temperature_nearing_limit',
    'temperature_excursion_pre_alarm',
    'viability_window_nearly_exhausted',
    'excessive_light_exposure_detected',
    'excessive_tilt_detected',
    'excessive_pressure_detected',
    'excessive_humidity_detected',
    'excessive_shock_detected',
    'delivery_overdue',
    'transport_provider_exception',
    'viability_window_risk_expiring',
    'viability_at_risk_before_arrival',
    'vessel_delayed_or_cancelled',
  ],
};

export const ALL_ALERT_IDS = new Set([
  ...(sectionMap?.alert_state || []),
  ...(sectionMap?.critical_alerts || []),
  ...(sectionMap?.at_risk_alerts || []),
  'processing',
  'needs_attention',
  'resolved_via_ai',
]);
